// CR-20260424-003 — UI render-loop lag indicator (FR-8 constants colocation).
// CR-20260515-003 — collapsed to two states (IDLE/WARNING) after LEAK-1
// removed auto-logout on CONFIRMED. CONFIRMED state, ESCALATION_INTERVAL_SECONDS,
// and the catastrophic-slip fast-path are gone — they only existed to reach
// the now-defunct latched terminal. STARTUP_GRACE_MS added so the login burst
// can't trip WARNING before the main thread has had a chance to settle.

export const DRIFT_THRESHOLD_SECONDS = 10;
export const SAMPLE_INTERVAL_MS = 1000;
export const VISIBILITY_GRACE_MS = 3000;
export const STARTUP_GRACE_MS = 3000;

export type DriftState = 'IDLE' | 'WARNING';

export interface DriftStateSnapshot {
   state: DriftState;
   observedDriftMs: number;
   timestamp: number;
}
